"use strict"
import React, { useState, useEffect, useGlobal, setGlobal } from 'reactn';
import EditAddress from '../../subPages/addNewAddress/AddNewAddress';
import { DeliveryBackupStyled, ModalWrapperStyled } from './DeliveryBackupStyled';
import Input from "shared-anpost-components/components/form/input/Input";
import AppHook from '../../../../hooks/appHook';
import DeliveryBackupCard from '../../../_common/deliveryBackupCard';
import DeleteConfirmationModal from '../../../_common/deleteConfirmationModal';
import { deleteAddress, deleteAutoDib, getJWTInfo, getProfile, getUserAddresses } from '../../../../services/Api';
import Icon from '../../../_common/icons/ReturnIcons';
import Loader from '../../../_common/loader/Loader';
import addressHooks from '../../../../hooks/addressHooks';
import ErrorMessage from '../../../_core/errorMessage';

const DeliveryBackup = ({ history, autoDIB }) => {
    const [existingAddresses, setExistingAddresses] = useState([]);
    const [notExistingAddresses, setNotExistingAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addressToDelete, setAddressToDelete] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [refetch, setRefetch] = useGlobal('refetch');
    const { values, setIndividualValue } = AppHook();
    const [profileData, setProfileData] = useState();
    const [overview, setOverview] = useState(false);
    const [selectedAddressOverview, setSelectedAddressOverview] = useState([]);
    const [addNewAddress, setAddNewAddress] = useState(true);
    const [backupToUpdate, setBackupToUpdate] = useState(null);
    const [overWrittenAddresses, setOverWrittenAddresses] = useState([]);
    const [apiError, setApiError] = useState(false);
    const {clearAddress} = addressHooks();
    const addressOvervewFormatter = (addressOverview) => {
        if (addressOverview) {
            const newAddresses = [];
            if (addressOverview.addressLine1) newAddresses.push(addressOverview.addressLine1);
            if (addressOverview.addressLine2) newAddresses.push(addressOverview.addressLine2);
            if (addressOverview.addressLine3) newAddresses.push(addressOverview.addressLine3);
            if (addressOverview.addressLine4) newAddresses.push(addressOverview.addressLine4);
            if (addressOverview.town) newAddresses.push(addressOverview.town);
            if (addressOverview.county) newAddresses.push(addressOverview.county);
            if (addressOverview.eircode) newAddresses.push(addressOverview.eircode);

            return newAddresses;
        }
    }


    const populateAddresshandler = () => {
        const updatedAddresses = [];

        if (data) {
            const newAddresses = new Set(existingAddresses.map(addr => addr.id));

            let filteredData;
            if (autoDIB && autoDIB.length) {
                filteredData = data.filter(el => el.id !== autoDIB[0].addressId);
            } else {
                filteredData = data;
            }

            for (let i = 0; i < filteredData.length; i++) {
                const value = `${filteredData[i].displayName}`;
                const description = `${filteredData[i].addressLine2 ? filteredData[i].addressLine2 + "," : ""} ${filteredData[i].addressLine3 ? filteredData[i].addressLine3 + "," : ""} ${filteredData[i].addressLine4 ? filteredData[i].addressLine4 + "," : ""} ${filteredData[i].postcode ? filteredData[i].postcode + "," : ""}  ${filteredData[i].addressLine1} ${filteredData[i].country}${filteredData[i].eircode ?  ", " + filteredData[i].eircode  : ""}`
                const id = filteredData[i].id;

                updatedAddresses.push({ id, value, description });
                newAddresses.add(id);
            }
            if (updatedAddresses.length > 0) {
                setExistingAddresses(updatedAddresses);
                setAddNewAddress(false)
            }
        }
    }

    const populateNonExistingAddressHandler = () => {
       
        if (profileData && profileData.length === 1) {
            if (profileData[0].displayName === "Home") {
                const value = `Business`;
                const id = 'business';
                    setNotExistingAddresses([{ id, value }]);
            } else {
                const value = `Home`;
                const id = 'home';
                    
                    setNotExistingAddresses([{ id, value }]);
             }


        } else if (profileData && profileData.length === 0) {
            setNotExistingAddresses([{ id: 'home', value: 'Home' }, { id: 'business', value: 'Business' }]);
         } else {
            setNotExistingAddresses([]);
         }
    }


    useEffect(() => {
            // Start loading
            setLoader(true);
            setOverWrittenAddresses([]);
            setBackupToUpdate(null);
            // Clear values
            values["personalAddressesList"] = null;
            values["safespotDescription"] = null;
            values["personalAddressAlias"] = null;
            values["neighboursName"] = null;
            values["neighboursAddress"] = null;
            values["personalAddress"] = null;
            values["addressBackup"] = null;
       
            setGlobal({ values });
            clearAddress("personalAddress");
            const handler = setTimeout(() => {
            const fetchData = async () => {
                try {
                    const res = await getUserAddresses(values.ciamUserId);
                    const responseData = res.data.addresses.filter(el => el.displayName === "Home" || el.displayName === "Business");
    
                    if (res.status === 200) {
                        setProfileData(responseData);
    
                        if (responseData.length && !autoDIB.length) {
                            setOverview(true);
                        }else if(!responseData.length && !autoDIB.length) {
                            setOverview(true);
                        }
                         else {
                            setOverview(false);
                        }
    
                        if (autoDIB && autoDIB.length) {
                            setEditMode(false);
                            const filteredData = responseData.filter(el => el.id !== autoDIB[0].addressId);
                            setData(filteredData);
                        } else {
                            setEditMode(true);
                            setData(responseData);
                        }
    
                    }
                } catch (error) {
                    console.error("Error fetching profile data", error);
                } finally {
                    // Stop loading once data fetching and processing are complete
                   
                    setLoader(false);
                }
            };
    
            fetchData();
            setSelectedAddressOverview([]);
            populateNonExistingAddressHandler();
            populateAddresshandler();
    
        }, 300); 
     
    
        return () => clearTimeout(handler);
    }, [autoDIB, refetch,]);
    
    const deleteAutoDibClick = () => {
        const data = {
            groupId: addressToDelete.id
        }
        setLoader(true);
        getJWTInfo().then(() => {
            deleteAutoDib(values.ciamUserId, data)
                .then(res => {
                    if (res.status === 200) {
                        setAddressToDelete(null);
                        setIndividualValue("addressBackup", null);
                        setIndividualValue("safespotDescription", null);
                        setIndividualValue("neighboursName", null);
                        setIndividualValue("neighboursAddress", null);
                        setSelectedAddressOverview([]);
                        setExistingAddresses([]);
                        if (autoDIB && autoDIB.length < 1) {
                            setEditMode(true);
                        };
                        setRefetch(!refetch);
                    }
                    setLoader(false);
                });
        })
    };

    useEffect(() => {
        if (backupToUpdate && autoDIB && autoDIB.length && profileData && profileData.length) {
            // const autodib = autoDIB.filter(el => el.addressId === backupToUpdate.id);
            setAddNewAddress(false);
            const address = profileData.filter(el => el.id === backupToUpdate.id);

            const value = `${address[0].displayName}`;
            const description = `${address[0].addressLine2 ? address[0].addressLine2 + "," : ""} ${address[0].addressLine3 ? address[0].addressLine3 + "," : ""} ${address[0].addressLine4 ? address[0].addressLine4 + "," : ""} ${address[0].postcode ? address[0].postcode + "," : ""} ${address[0].addressLine1}`
            const id = address[0].id;


            const isDuplicate = existingAddresses.filter(el => el.id === id);
            const newExisting = [{ value, id }];
            isDuplicate && setOverWrittenAddresses(newExisting)

            values["personalAddressesList"] = [{ value, description, id }];
            values["addressBackup"] = backupToUpdate.deliveryType === "Safe spot" ? "safespot" : "neighbour";
            values["safespotDescription"] = backupToUpdate.deliveryType === "Safe spot" ? backupToUpdate.addressType : null;
            values["neighboursName"] = backupToUpdate.deliveryType === "To a neighbour" ? backupToUpdate.neighboursName : null;
            values["neighboursAddress"] = backupToUpdate.deliveryType === "To a neighbour" ? backupToUpdate.neighboursAddress : null;
            setSelectedAddressOverview(addressOvervewFormatter(address[0]));
            setGlobal({ values });
        }
        setEditMode(true)


    }, [backupToUpdate])

    useEffect(() => {


        if (existingAddresses.length > 0 && values["personalAddressesList"]) {
            const a = values["personalAddressesList"] || values["personalAddressesList"][0].value;
            const selectedAddr = data.find(addr => addr.displayName === a);
            if (selectedAddr) {
                setSelectedAddress(selectedAddr);

            }
        }
        populateAddresshandler();
        populateNonExistingAddressHandler();
    }, [values["personalAddressesList"], profileData, data]);

    useEffect(() => {
        if (selectedAddress) {
            setSelectedAddressOverview(addressOvervewFormatter(selectedAddress));
        }
    }, [selectedAddress]);


    const addNewAddressHandler = () => {
        if (data && data.length < 2) {
            setExistingAddresses([]);
            setAddNewAddress(true)
        }
    }

    const editModeHandler = () => {
        if (autoDIB && autoDIB.length < 2) {
            setEditMode(true);
            if(profileData && profileData.length === 1) {
                setAddNewAddress(true);
            }
        }
    }

    const AddNewAddressBackupConfig = {
        backText: "Back",
        heading: "Add a new delivery backup",
        fields: [

            {
                id: "personalAddress",
                displayText: "Address",
                disableManualEntry: true,
                formType: "address",
               
            },
            {
                id: "personalAddressAlias",
                displayText: "Type of address",
                formType: "select",
                required: true,
                options: notExistingAddresses
            },
            {
                id: "addressBackup",
                displayText: "Add delivery backup",
                formType: "select",
                required: true,
                options: [{ id: "safe-spot", value: "safespot", name: "In a safe spot" }, { id: "neighbour", value: "neighbour", name: "To a neighbour" }],
            },
            values["addressBackup"] === "safespot" && {
                id: "safespotDescription",
                displayText: "Description",
                disableManualEntry: true,
                formType: "input",
                reqired: true,
                helperText: "Eg. a dry, safe location, hidden from view",
            },

            values["addressBackup"] === "neighbour" && {
                id: "neighboursName",
                displayText: "Neighbour's name",
                disableManualEntry: true,
                formType: "input",
                required: true,
            },

            values["addressBackup"] === "neighbour" && {
                id: "neighboursAddress",
                displayText: "Neighbour's address",
                disableManualEntry: true,
                formType: "input",
                required: true,
            },
        ]
    };


    const AddExistingAddressBackupConfig = {
        backText: "Back",
        heading: "Add a new delivery backup",
        fields: [
            {
                id: "personalAddressesList",
                displayText: "Address",
                formType: "select",
                required: true,
                disabled: backupToUpdate !== null ? true : false,
                options: overWrittenAddresses && overWrittenAddresses.length ? overWrittenAddresses : existingAddresses,
                handler: profileData && profileData.length < 2 ? {
                    handlerFunction: () => addNewAddressHandler(),
                    handlerLabel: { id: "addNewAddress", value: "handler", name: `Add ${data && data.length && data[0].displayName === "Home" ? "Business" : "Home"} address` }
                } : ""

            },

            selectedAddressOverview.length && {
                id: "addressPreview",
                data: selectedAddressOverview,
                formType: "noForm",
            },
            {
                id: "addressBackup",
                displayText: "Add delivery backup",
                formType: "select",
                required: true,
                preselect: backupToUpdate !== null ? "null" : false,
                options: [{ id: "safe-spot", value: "safespot", name: "In a safe spot" }, { id: "neighbour", value: "neighbour", name: "To a neighbour" }],
            },
            values["addressBackup"] === "safespot" && {
                id: "safespotDescription",
                displayText: "Description",
                disableManualEntry: true,
                formType: "input",
                required: true,
                helperText: "Eg. a dry, safe location, hidden from view",
            },

            values["addressBackup"] === "neighbour" && {
                id: "neighboursName",
                displayText: "Neighbour's name", 
                disableManualEntry: true,
                formType: "input",
                required: true,

            },

            values["addressBackup"] === "neighbour" && {
                id: "neighboursAddress",
                displayText: "Neighbour's address",
                disableManualEntry: true,
                formType: "input",
                required: true,
            },
        ]
    };
  const handleRetry = () => {
        setApiError(false);
        window.location.reload();
   }

    return (
        <DeliveryBackupStyled>
            {loader ? <Loader /> :
                apiError ? <ErrorMessage message={"We’re sorry but we couldn’t add your delivery backup."} tryAgainEvent={handleRetry} /> : <>
                    {!editMode ? (
                        <div className='backupSectionWrapper'>
                            <div className='backupCardWrapper'>
                                {autoDIB && autoDIB.length > 0 && autoDIB.map((addr, index) => (
                                    <DeliveryBackupCard
                                        key={index}
                                        addressType={addr}
                                        profileData={profileData}
                                        setEditMode={setBackupToUpdate}
                                        setAddressToDelete={setAddressToDelete}
                                    />
                                ))}
                            </div>
                            {autoDIB.length < 2 && (
                                <span className='addBackupWrapper gtm-linkclick' onClick={editModeHandler}>
                                    <Icon src='plusIcon' /> Add another delivery backup
                                </span>
                            )}
                        </div>
                    ) : !overview ? (
                        <EditAddress
                            onError={(e) => setApiError(e)}
                            addressConfig={ addNewAddress ? AddNewAddressBackupConfig : AddExistingAddressBackupConfig}
                            backupInfo={existingAddresses.length > 0 && !addNewAddress}
                            history={history}
                            selectedAddressId={selectedAddress ? selectedAddress.id : ""}
                            toUpdate={backupToUpdate}
                        />
                    ) : (
                        !loader && <div className='overviewWrapper'>
                        <div className='overviewTextWrapper'>
                            <span className='overviewTitle'>My delivery backup</span>
                            <span className='overviewText'>
                                Did you know you can set a safe spot or a neighbour as a permanent backup for An Post deliveries when you’re not around?
                            </span>
                        </div>
                        <span className='addBackupTextHandler gtm-linkclick' onClick={() => setOverview(false)}>
                            <Icon src='plusIcon' /> Add a delivery backup
                        </span>
                    </div>
                    )}

                    <DeleteConfirmationModal show={Boolean(addressToDelete)} onClose={() => setAddressToDelete(null)}>
                        <ModalWrapperStyled>
                            <div className='infoWrapper'>
                                <span className='modaltext title'>
                                    Are you sure you want to delete your backup option?
                                </span>
                                <span className='modaltext modalAddress'>
                                    {addressToDelete?.address.map((addr, index) => (
                                        <span className='modaltext' key={index}>{addr}</span>
                                    ))}
                                </span>
                                <span className='modaltext backupWrapper'>
                                    <span className='modaltext title'>Delivery backup option</span>
                                    <span className='modaltext'>{addressToDelete?.deliveryType || ""}</span>
                                </span>
                                <span className='modaltext'>
                                    {`'${addressToDelete?.addressType || ""}'`}
                                </span>
                            </div>
                            <div className='buttonWrapper'>
                                <button className='modalButton cancelButton' onClick={() => setAddressToDelete(null)}>Cancel</button>
                                <button className='modalButton deleteButton' onClick={deleteAutoDibClick}>Delete</button>
                            </div>
                        </ModalWrapperStyled>
                    </DeleteConfirmationModal>
                </>
            }
        </DeliveryBackupStyled>

    );
};

export default DeliveryBackup;